import type {SearchHistoryEntryDto} from 'src/typings';
import {ngAsync} from 'shared/utils/ng-@decorators';
import type {AjaxService} from 'core/data-services/ajax.service';

/**
 * @ngdoc service
 * @name searchHistoryDataService
 * @module portaro.search
 *
 * @description
 * Data service for search history.
 */

export default class SearchHistoryDataService {
    public static serviceName = 'searchHistoryDataService';

    private static readonly SEARCH_HISTORY_ROUTE = 'search-history';

    /*@ngInject*/
    constructor(private ajaxService: AjaxService) {
    }

    @ngAsync()
    public async getAll(sorting: string = '-date'): Promise<SearchHistoryEntryDto[]> {
        return this.ajaxService
            .createRequest(SearchHistoryDataService.SEARCH_HISTORY_ROUTE)
            .get({sorting});
    }
}